/* src/app/components/lead-details/participant-information/lead-fms-data/lead-fms-data.component.css */
.nz-padding-left {
  padding-left: 1rem;
}
/*# sourceMappingURL=lead-fms-data.component-EPGPQUFV.css.map */
